<template>
  <o-form-group :label="label">
    <o-timepicker-control v-model="localValue"></o-timepicker-control>
  </o-form-group>
</template>

<script>
  export default {
    name: 'o-timepicker',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
